import { Injectable } from '@angular/core';
import { ProxyService } from '@core/services/proxy.service';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { Router } from '@angular/router';
import { SelectPickupService } from './select-pickup.service';
import { environment } from '@environments/environment';
import { UtilitiesService } from '@core/services';
import { Constants } from '@core/constants/core.constants';

@Injectable({
  providedIn: 'root'
})
export class RecentOrdersService {

  constructor(private router: Router, private proxyService: ProxyService,
    private selectPickupService: SelectPickupService) { }

  getRecentOrders(count: number = 3) {
    return this.proxyService.httpGet(ApiRoutes.GET_RECENT_ORDERS_INFO + '/' + count);
  }

  addToCart(orderId: string) {
    if(environment.features.deliveryFrontOfFlow) {
      this.selectPickupService.showPickupModal(orderId, 'order','Home');
    } else {
      this.router.navigate(['/menu'], {
        queryParams: UtilitiesService.generateQueryParams([Constants.ORDER_ID],[orderId])
      });
    }
  }
}
